// ================================================================================
// Custom events
//
// To help make it easier to add custom functionality, the theme emits custom
// events (along with their associated data) related to key theme features.
//
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.
// ================================================================================

/* eslint-disable no-console */

/* hide icons in cart and quick view */
document.addEventListener("DOMContentLoaded", function() {
    var quickCart = document.querySelector('.quick-cart__wrapper');
    var quickProductModal = document.querySelector('.quick-product-modal');
  
    // Check if quickCart is found
    if (!quickCart && !quickProductModal) {
        //console.log("quick-cart__wrapper not found.");
        return;
    }
  
    // Monitor changes in the class attribute of the quick cart wrapper
    var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.attributeName === 'class') {
                //console.log("Class attribute changed on quick-cart__wrapper.");
                
                // Check if the 'active' class is added
                if (quickCart.classList.contains('active') || quickProductModal.classList.contains('active')) {
                    //console.log("quick-cart__wrapper is active. Hiding elements.");
                    
                    var elementsToHide = document.querySelectorAll('[class*="kl-teaser"], .gb_main_container, .back-to-top, .jdgm-popup-widget-wrapper');
                    elementsToHide.forEach(function(element) {
                        //console.log("Hiding element: ", element);
                        element.style.display = 'none';
                    });
                } else {
                    //console.log("quick-cart__wrapper is not active. Showing elements.");

                    var elementsToHide = document.querySelectorAll('[class*="kl-teaser"], .gb_main_container, .back-to-top, .jdgm-popup-widget-wrapper');
                    elementsToHide.forEach(function(element) {
                        //console.log("Showing element: ", element);
                        element.style.display = '';
                    });
                }
            }
        });
    });

    if (quickCart) {
        observer.observe(quickCart, { attributes: true });
    }
    if (quickProductModal) {
        observer.observe(quickProductModal, { attributes: true });
    }
});

// ================================================================================
// "Item added to the cart"
//
// - Fires whenever an item has been added to the cart
// - Exposed when the ajax cart is enabled
// - "detail" object data:
//   - The associated product object
// ================================================================================
document.addEventListener("cart:item-added", function (evt) {
    console.log("Item added to the cart");
    console.log(evt.detail.product);

    // List of SKUs that qualify for a free item
    const eligibleSkus = [
        //"0-SU-FLWR-FFLYF-DIDU-7066",
        //"0-SU-FLWR-FFLYF-GEOG-7080",
        //"0-SU-FLWR-FFLYF-JEFU-7073",
        //"0-SU-FLWR-FFLYF-PICP-7097",
    ];

    // The free item variant ID that should be added
    const freeItemVariantId = 49569985233175; // Replace with actual free item variant ID

    function checkAndAddFreeItem(addedProduct) {
        if (!addedProduct) {
            return;
        }

        const addedSku = addedProduct.sku || addedProduct.variants?.[0]?.sku;

        if (!addedSku) {
            return;
        }

        if (!eligibleSkus.includes(addedSku)) {
            return;
        }

        fetch(`/cart.js?t=${Date.now()}`) // Cache-busting URL
            .then(response => response.json())
            .then(cart => {
                let freeItemExists = cart.items.some(item => item.variant_id === freeItemVariantId);
                let eligibleItem = cart.items.find(item => item.sku === addedSku);

                if (!eligibleItem) {
                    return;
                }

                if (!freeItemExists) {
                    let formData = {
                        'items': [{
                            'id': freeItemVariantId,
                            'quantity': eligibleItem.quantity
                        }]
                    };

                    setTimeout(() => {
                        fetch(window.Shopify.routes.root + 'cart/add.js', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({
                                id: freeItemVariantId,
                                quantity: eligibleItem.quantity
                            })
                        }).then(response => response.json())
                          .then(() => location.reload())
                          .catch(error => console.error("❌ ERROR adding free item:", error));
                    }, 500); // 500ms delay
                }
            })
            .catch(error => console.error("❌ ERROR fetching cart data:", error));
    }

    checkAndAddFreeItem(evt.detail.product);
});


// ================================================================================
// "Cart updated"
//
// - Fires whenever the cart is updated
// - Exposed when the ajax cart is enabled
// - "detail" object data:
//   - The cart object
// ================================================================================
document.addEventListener("cart:updated", function (evt) {
  console.log("Cart updated");
  console.log(evt.detail.cart);
});

// ================================================================================
// "Cart error"
//
// - Fires whenever there is an error when adding an item to the cart
//   - Typically due to a product not having sufficient stock
// - "detail" object data:
//   - The error message
// ================================================================================
document.addEventListener("cart:error", function (evt) {
  console.log("Cart error");
  console.log(evt.detail.errorMessage);
});

// ================================================================================
// "Quick cart opened"
//
// - Fires whenever the quick cart is opened
// - Exposed when the ajax cart is enabled
// - "detail" object data:
//   - The cart object
// ================================================================================
document.addEventListener("quick-cart:open", function (evt) {
  console.log("Quick cart opened");
  console.log(evt.detail.cart);
});

// ================================================================================
// "Quick cart closed"
//
// - Fires whenever the quick cart is opened
// - Exposed when the ajax cart is enabled
// ================================================================================
document.addEventListener("quick-cart:close", function () {
  console.log("Quick cart closed");
});

// ================================================================================
// "Product variant changed"
//
// - Fires whenever a variant product is selected
// - Exposed when a 'Variant selectors' block has been added to a product template
//   or featured product section
// - "detail" object data:
//   - The variant object
// ================================================================================
document.addEventListener("product:variant-change", function (evt) {
  console.log("Product variant changed");
  //console.log(evt.detail.variant);
  //console.log(evt.detail.variant.id);
  
  //Referencing an array created in theme.liquid
  //array updated in main-product--default.liquid
  //array updated in main-collection-product-grid.liquid
  const currentVariant = evt.detail.variant;

  //Strength
  const variantLabelStrength = document.getElementById(`custom-metafield-strength`);
  if (variantLabelStrength && variantMetafieldStrength){
    if (variantMetafieldStrength[evt.detail.variant.id] !== undefined) {
      variantLabelStrength.textContent = variantMetafieldStrength[evt.detail.variant.id] + " Strength";
    }
  }
  
  //Strength Image URL
  const variantLabelStrengthURL = document.getElementById(`custom-metafield-strength-url`);
  if (variantLabelStrengthURL && variantMetafieldStrengthURL){
    if (variantMetafieldStrengthURL[evt.detail.variant.id] !== undefined) {
      variantLabelStrengthURL.src = variantMetafieldStrengthURL[evt.detail.variant.id];
    }
  }
  
  // Effect
  const variantLabelEffect = document.getElementById('custom-metafield-effect');
  const variantLabelEffectDiv = document.getElementById('custom-metafield-effect-div');

  //console.log(variantMetafieldEffect && variantLabelEffect && variantLabelEffectDiv);
  if (variantMetafieldEffect && variantLabelEffect && variantLabelEffectDiv){

    //console.log(evt.detail.variant.id);
    //console.log(variantMetafieldEffect[evt.detail.variant.id]);
    if (variantMetafieldEffect[evt.detail.variant.id] !== undefined) {
      
      const effect = variantMetafieldEffect[evt.detail.variant.id];
      variantLabelEffect.textContent = effect;
      //console.log(variantLabelEffect.textContent);
      
      let effectColor = '';
  
      switch (effect) {
        case 'Energy':
          effectColor = '#DF4661';
          break;
        case 'Create':
        case 'Clarity':
        case 'Focus':
          effectColor = '#F2A900';
          break;
        case 'Uplift':
          effectColor = '#78BE21';
          break;
        case 'Relax':
        case 'Rest':
          effectColor = '#B4B5DF';
          break;
        case 'Euphoria':
          effectColor = '#68478D';
          break;
        default:
          effectColor = '#000000'; // Default color if effect does not match
      }
  
      variantLabelEffectDiv.style.backgroundColor = effectColor;
    }
  }

  //Strain
  const variantLabelStrain = document.getElementById(`custom-metafield-strain`);
  if (variantLabelStrain && variantMetafieldStrain){
    if (variantMetafieldStrain[evt.detail.variant.id] !== undefined) {
      variantLabelStrain.textContent = variantMetafieldStrain[evt.detail.variant.id];
    }
  }

  //Description
  const variantLabelDescription = document.getElementById(`custom-metafield-description`);
  if (variantLabelDescription && variantMetafieldDescription){
    if (variantMetafieldDescription[evt.detail.variant.id] !== undefined) {
      variantLabelDescription.innerHTML = variantMetafieldDescription[evt.detail.variant.id];
    }
  }

  // COA - Single Link by SKU
  const coaLink = document.getElementById("coa-link");
  if (coaLink) {
    const variant = evt.detail.variant;
    if (variant && variant.sku) {
      coaLink.href = "https://coa.urb.shop/?sku=" + encodeURIComponent(variant.sku);
      coaLink.textContent = "View COA";
    } else {
      coaLink.removeAttribute("href");
      coaLink.textContent = "No COA available for this variant.";
    }
  }

  // Earn Miles
  //console.log(currentVariant.price);
  const milesRaw = (currentVariant.price / 100.0) * 5;
  const miles = Math.floor(milesRaw);

  const earnMiles = document.getElementById('urb-earn-miles');
  if (earnMiles) {
    earnMiles.innerHTML = `Complete purchase to earn <b>${miles}</b> Urb Miles.`;
  }

});


// ================================================================================
// "Product quantity updated"
//
// - Fires whenever a product quanatiy is updated
// - Exposed when a 'Quantity selector' block has been added to a product template
//   or featured product section
// - "detail" object data:
//   - The variant object
//   - The quantity
// ================================================================================
document.addEventListener("product:quantity-update", function (evt) {
  console.log("Product quantity updated");
  console.log(evt.detail.quantity, evt.detail.variant);
});

// ================================================================================
// "Quick view loaded"
//
// - Fires whenever a quick view modal is opened
// - Exposed when the 'Enable quick view' setting is enabled and a quick view
//   modal is opened
// ================================================================================
document.addEventListener("quick-view:loaded", function () {
  console.log("Quick view loaded");
});
/* eslint-enable no-console */








